import React, { useState } from 'react';
import api from '../services/api';

function AddThanNhanModal({ onClose, onSave }) {
  const [formData, setFormData] = useState({
    ho_ten: '',
    nam_sinh: '', // (*** SỬA ***) Thay 'ngay_sinh' bằng 'nam_sinh'
    cccd: '', 
    dia_chi: ''
  });
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  // (*** SỬA ***)
  const { ho_ten, nam_sinh, cccd, dia_chi } = formData;

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // (*** SỬA ***) Thêm validation cho nam_sinh
    if (!ho_ten || !nam_sinh || !cccd || !dia_chi) {
       setError('Họ tên, Năm sinh, CCCD và Địa chỉ là bắt buộc.');
       return;
    }
    
    if (!/^\d{4}$/.test(nam_sinh)) {
        setError('Năm sinh phải là 4 chữ số (ví dụ: 1950).');
        return;
    }
    
    if (cccd.length < 3) {
      setError('CCCD phải có ít nhất 3 ký tự (sẽ chỉ lưu 3 số cuối).');
      return;
    }

    setIsSaving(true);
    try {
      // (*** SỬA ***) Gửi 'nam_sinh' lên API
      const res = await api.post('/than-nhan', {
        ho_ten,
        nam_sinh: nam_sinh,
        cccd,
        dia_chi
      });
      
      onSave(res.data); 
      onClose();

    } catch (err) {
      setError(err.response?.data?.message || 'Lỗi khi thêm mới');
      setIsSaving(false);
    }
  };

  // (CSS giữ nguyên)
  const modalStyles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' },
    content: { background: 'white', padding: '20px', borderRadius: '8px', width: '90%', maxWidth: '500px' },
    h3: { marginTop: '0' },
    grid: { display: 'grid', gridTemplateColumns: '1fr', gap: '15px' },
    inputGroup: { display: 'flex', flexDirection: 'column' },
    button: { background: '#007bff', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '4px', cursor: 'pointer', marginRight: '10px' },
    closeButton: { background: '#ccc', color: 'black' },
    error: { color: 'red', fontWeight: 'bold' }
  };


  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.content} onClick={e => e.stopPropagation()}>
        <h3 style={modalStyles.h3}>Thêm mới Thân nhân</h3>
        
        <form onSubmit={handleSubmit}>
          <div style={modalStyles.grid}>
            <div style={modalStyles.inputGroup}>
              <label>Họ tên (bắt buộc):</label>
              <input name="ho_ten" value={ho_ten} onChange={onChange} required />
            </div>
            
            {/* (*** SỬA ***) Thay 'ngay_sinh' bằng 'nam_sinh' */}
            <div style={modalStyles.inputGroup}>
              <label>Năm sinh (bắt buộc):</label>
              <input 
                type="text" 
                name="nam_sinh" 
                value={nam_sinh} 
                onChange={onChange} 
                placeholder="YYYY (ví dụ: 1950)" 
                maxLength={4}
                required 
              />
            </div>
            
            <div style={modalStyles.inputGroup}>
              <label>CCCD (bắt buộc, sẽ chỉ lưu 3 số cuối):</label>
              <input name="cccd" value={cccd} onChange={onChange} placeholder="Nhập đủ số CCCD" required />
            </div>
            
            <div style={modalStyles.inputGroup}>
              <label>Địa chỉ (bắt buộc):</label>
              <input name="dia_chi" value={dia_chi} onChange={onChange} required />
            </div>
          </div>
          
          {error && <p style={modalStyles.error}>{error}</p>}
          
          <div style={{textAlign: 'right', marginTop: '20px'}}>
            <button style={{...modalStyles.button, ...modalStyles.closeButton}} onClick={onClose} disabled={isSaving} type="button">
              Hủy
            </button>
            <button style={modalStyles.button} type="submit" disabled={isSaving}>
              {isSaving ? 'Đang lưu...' : 'Lưu'}
            </button>
          </div>
        </form>
        
      </div>
    </div>
  );
}

export default AddThanNhanModal;